<script lang="ts" setup>
const { t } = useI18n()
</script>

<template>
  <div>
    <div
      class="bg-[linear-gradient(50deg,#000_40%,#7540EE60_65%,#0F0F0F_75%)] py-3.5 max-w-237.25 mx-auto min-h-61.25 px-10 flex flex-col items-center justify-center rounded-xl relative"
    >
      <div
        class="text-center text-2xl leading-normal tracking-wide lg:text-[1.75rem]"
      >
        {{ t('join-the-revolution') }}
      </div>
      <div class="flex flex-row mt-8 gap-5 flex-wrap justify-center">
        <ReusableInstallButtons />
      </div>
    </div>
  </div>
</template>
